import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";

import { PublicOrganization } from "~/graphql";
import { publicPath } from "~/utils/path";

type Props = {
  page: "select_reservation_time" | "completed";
  pharmacy: PublicOrganization;
};

const DownloadLink = styled("a")({
  display: "block",
  width: "100%",
});

const DownloadBanner = styled("img")({
  display: "block",
  width: "100%",
});

export const AppDownloadBanner = (props: Props) => {
  const [link, setLink] = useState("#");

  useEffect(() => {
    const url = new URL(process.env.appDownloadUrl);
    url.searchParams.append("~campaign", "download");
    url.searchParams.append("~tags", `page:${props.page}`);
    url.searchParams.append("~tags", `organization:${props.pharmacy.rawId}`);
    url.searchParams.append("path", "pharmacies/show");
    url.searchParams.append("organizationId", props.pharmacy.rawId);
    url.searchParams.append("bookmarkSuggestion", "true");
    setLink(url.toString());
  }, [props.page, props.pharmacy.rawId]);

  return (
    <DownloadLink href={link}>
      <DownloadBanner
        src={publicPath("/images/img-app-download.svg")}
        alt="CLINICSアプリなら患者情報を次回から入力せず処方箋を送れます"
      />
    </DownloadLink>
  );
};
